module.exports = "<div class=\"weui_uploader_files\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/uploader/uploader-files.vue
 ** module id = 129
 ** module chunks = 0
 **/